/*
 * Public API Surface of ngx-json-viewer
 */

export * from './lib/ngx-json-viewer/ngx-json-viewer.component';
export * from './lib/ngx-json-viewer.module';
